<template>
  <div>
    <ul class="learnedList">
      <li class="list-item" v-for="(item, key) in learnedList" :key="key">
        <div class="item-img" @click="playClick(item.curriculumName, item.mxVedio, item.mxId, item.curriculumStageId)"><img :src="item.mxImg" alt="课时图片"></div>
        <div class="list-content">
          <div class="item-describe" v-if="false">记录ID：{{item.studyId}}</div>
          <div class="item-describe">课程名称：{{item.olCurriculumName}}</div>
          <div class="item-describe" v-if="false">阶段ID：{{item.stageId}}</div>
          <div class="item-describe">阶段名称：{{item.olStageName}}</div>
          <div class="item-describe" v-if="false">课时ID：{{item.mxId}}</div>
          <div class="item-describe">课时名称：{{item.mxTitle}}</div>
          <div class="item-describe">首次播放时间：{{item.studyCreatetime}}</div>
          <div class="item-describe">当前学习时长：{{item.studyTime}}分</div>
          <div class="item-describe">当前播放状态：{{item.olFinish == '1' ? '已结束' : '进行中'}}</div>
          <el-button class="answerBtn" v-if="item.olMxState == '0' && item.olFinish == '1'" round type="primary" size="mini" @click="answerBtnClick(3,item.mxId)">课时答题</el-button>
          <el-button class="answerBtn" v-if="item.olStageState == '0' " round type="primary" size="mini" @click="answerBtnClick(2,item.curriculumStageId)">阶段答题</el-button>
        </div>
      </li>
    </ul>
    <play-view v-if="playVisible" :src="src" :title="title" :mxId="mxId" :olCurriculumStage="olCurriculumStage"></play-view>
    <answer-view v-if="answerLearned && !playVisible" :type="answerType" :answerId="answerId"></answer-view>
  </div>
</template>

<script>
import {mapMutations, mapState} from 'vuex'
import playView from './playView'
import answerView from './answerView'
export default {
  name: 'learnedList',
  props: ['learnedList', 'showPlay'],
  computed: {
    ...mapState(['playVisible', 'answerVisible'])
  },
  data () {
    return {
      src: 'http://www.sxlihang.cn/third.mp4',
      title: '',
      answerType: 0,
      answerId: '',
      mxId: '',
      olCurriculumStage: '',
      answerLearned: false
    }
  },
  components: {
    playView,
    answerView
  },
  methods: {
    ...mapMutations(['setPlayVisible', 'setAnswerVisible']),
    playClick (title, src, id, olCurriculumStage) {
      this.title = title
      this.src = src
      this.mxId = id
      this.olCurriculumStage = olCurriculumStage
      this.setPlayVisible(true)
    },
    answerBtnClick (val, id) {
      // window.open('../../static/answer.html')
      this.answerLearned = true
      this.setAnswerVisible(true)
      this.answerType = val
      this.answerId = id
    }
  }
}
</script>

<style lang="scss" scoped>
.learnedList{
  display: flex;
  flex-wrap: wrap;
  .list-item{
    width: 265px;
    border: 1px solid #666666;
    margin: 0px 30px 30px 0px;
    cursor: pointer;
    .item-img{
      width: 100%;
      height: 160px;
      img{
        width: 100%;
        height: 100%;
      }
    }
    .list-content{
      width: 100%;
      padding: 10px;
      div{
        line-height: 20px;
        color: #666666;
      }
      .answerBtn{
        width: 100%;
        margin-top: 10px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/learnedList.vue